module.exports = __webpack_public_path__ + "images/8129ae8e.jpg";